export function throttle<T extends Function>(cb: T, wait = 20) {
	let inThrottle: boolean = false;
	let callable = (...args: any) => {
		if (!inThrottle) {
			cb(...args);
			inThrottle = true;
			setTimeout(() => (inThrottle = false), wait);
		}
	};
	return callable as any as T;
}
